"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _Constants = require("../../Constants");

var SVGBase = function SVGBase(props) {
  var __isHasMore = props._isHasMore,
      __isListReversed = props._isListReversed,
      __src = props.src,
      __styledJunk0 = props['0'],
      __styledJunk1 = props['1'],
      rest = (0, _objectWithoutProperties2.default)(props, ["_isHasMore", "_isListReversed", "src", "0", "1"]);
  return _react.default.createElement("svg", Object.assign({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest));
};

SVGBase.propTypes = {
  size: _propTypes.default.oneOf(Object.keys(_Constants.AVATAR_SIZES)),
  _isHasMore: _propTypes.default.bool,
  _isListReversed: _propTypes.default.bool,
  '0': _propTypes.default.any,
  '1': _propTypes.default.any,
  src: _propTypes.default.string
};
var _default = SVGBase;
exports.default = _default;
module.exports = exports.default;